import { Color } from '../../color.model';

export const cyan: Color = {
  light: {
    1: 'hsl(185, 60.0%, 98.7%)',
    2: 'hsl(185, 73.3%, 97.1%)',
    3: 'hsl(186, 70.2%, 94.4%)',
    4: 'hsl(186, 63.8%, 90.6%)',
    5: 'hsl(187, 58.3%, 85.4%)',
    6: 'hsl(188, 54.6%, 78.4%)',
    7: 'hsl(189, 53.7%, 68.7%)',
    8: 'hsl(189, 60.3%, 52.5%)',
    9: 'hsl(190, 95.0%, 39.0%)',
    10: 'hsl(191, 91.2%, 36.8%)',
    11: 'hsl(192, 85.0%, 31.0%)',
    12: 'hsl(192, 88.0%, 12.5%)',
  },
  dark: {
    1: 'hsl(192, 60.0%, 7.2%)',
    2: 'hsl(192, 71.4%, 8.2%)',
    3: 'hsl(192, 75.9%, 10.8%)',
    4: 'hsl(192, 79.3%, 12.8%)',
    5: 'hsl(192, 82.5%, 14.6%)',
    6: 'hsl(192, 86.6%, 16.9%)',
    7: 'hsl(192, 92.6%, 20.1%)',
    8: 'hsl(192, 100%, 24.5%)',
    9: 'hsl(190, 95.0%, 39.0%)',
    10: 'hsl(188, 100%, 40.0%)',
    11: 'hsl(186, 100%, 42.2%)',
    12: 'hsl(185, 73.0%, 93.2%)',
  },
};
